import Vue from 'vue'
import { Swipe, SwipeItem, ImagePreview } from 'vant'

Vue.use(ImagePreview)
Vue.use(Swipe).use(SwipeItem)
